export { default as ChatGptSolidIcon } from './ChatGptSolidIcon';
